import { gateway } from "../../../../gateway";

export const getTotalWorkforce = async () => {
    const token = sessionStorage.getItem("token")
    try {
        const response = await gateway.get(`/workforce/role-counts`, {
            headers: {
                Authorization: `${token}`,
            },
        });

        return response.data.data;
    } catch (error) {
        console.error("Error al obtener total de workforce", error);
        throw error;
    }
}